const section = {
  about: 'Tentang saya',
  projects: 'Proyek',
  blogs: 'Blog',
  skills: 'Kemampuan',
  contact: 'Hubungi saya 🤙',
  projectDetails: 'Lihat',
  seeMoreGithub: 'Lihat Selengkapnya',
  moreArticle: 'Artikel lainnya',
  downloadResume: 'Unduh Resume',
};

export default section;
